import { render, staticRenderFns } from "./contractRenew.vue?vue&type=template&id=20b0fcdf&scoped=true&"
import script from "./contractRenew.vue?vue&type=script&lang=js&"
export * from "./contractRenew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0fcdf",
  null
  
)

export default component.exports